module.exports = __webpack_public_path__ + "img/2-6.be0bd311.svg";